import React, { useCallback, useEffect, useRef, useState } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { connect, useSelector } from 'react-redux'
import MainRoutes from './routes/MainRoutes'
import { fetchUniversityDetails } from './redux/slices/universitySlice';
import CustomizedSnackbars from './components/shared/Toast/ToastContainer'
import { getSubdomain } from './lib/utils/subDomainUtils';
import { getUserDetails } from './redux/slices/userSlice'
import { storage } from './config/storage'
import { session } from './redux/slices/sessionSlice';
import { getCurrentSeasons } from './redux/slices/seasonSlice';
import { getMyCart } from './redux/slices/cartSlice';
import CommonLoader from './components/shared/Loaders/CommonLoader/CommonLoader';
import { fetchUserPointsAndRewards } from './redux/slices/rewardSlice';
import RequestToChangePassword from './components/RequestToChangePassword/RequestToChangePassword';
import { getPasswordPolicy } from './redux/slices/passwordPolicySlice';
import UserFirstLoginModal from './components/shared/Modals/UserFirstLoginModal/UserFirstLoginModal';
import { getLiveMatchesList } from './redux/slices/sportSlice';
import FeedbackButton from './components/shared/Others/FeedbackButton/FeedbackButton';

const App = ({ getSession, fetchUniversity, getUser, getCart, getCurrentSeasons, fetchPointsAndRewards, passwordPolicies, getLiveMatches }) => {
  const isMounted = useRef(false);
  const isMounted2 = useRef(false);
  const isMounted3 = useRef(false);
  const { isSession } = useSelector((state) => state.session);
  const { isSignedIn, user } = useSelector((state) => state.user);
  const { universityId } = useSelector((state) => state.university)
  const { fetchingSeasons, currentSeason } = useSelector((state) => state.seasons);

  const [isModalOpen, setIsModalOpen] = useState(false);

  // This function closes the modal
  const handleModalClose = () => {
    setIsModalOpen(false); // Close the modal
  };

  const initializeSession = useCallback(async() => {
    if (isMounted.current) return; // Skip effect if already mounted
    isMounted.current = true; // Mark as mounted
    
    // Fetch token from localStorage
    const token = storage.fetchFromLocalStorage.token();
    // Fetch subdomain from URL
    const subDomain = getSubdomain(window.location.hostname); // getSubdomain function is being called from subdomainUtils.js to get the subdomain from the URL

    // Check session key and state to avoid redundant session creation
    if (!isSession) {
      await getSession(); // get Session Details
    }
    if(!universityId){
      await fetchUniversity({ subDomain }) // fetch University Details
    }
    if(token && token !== "undefined" && isSignedIn){
      await getUser(); // get updated user-info
    }
  }, [fetchUniversity, getSession, getUser, isSession, universityId, isSignedIn]);

  useEffect(() => {
    if(isMounted3.current || !universityId) return
    isMounted3.current = true

    passwordPolicies(); 
  }, [universityId]);

  useEffect(() => {
    if (isMounted2.current || !isSignedIn) return; // Skip effect if already mounted
    if(isSignedIn){
      isMounted2.current = true;

      const queryParams = new URLSearchParams(window.location.search);
      const paymentIntent = queryParams.get('payment_intent');   // Payment Intent
      const redirectStatus = queryParams.get('redirect_status'); // Succeeded or Failed
      const orderId = queryParams.get('orderId'); // Order Id
      const seasonId = queryParams.get('seasonId'); // Season Id

      if(paymentIntent && redirectStatus && orderId && seasonId){
        getCurrentSeasons({ seasonId }) // get current Seasons Detail
      }else {
        getCurrentSeasons() // get current Seasons Detail
      }
      
      
      // This conditions opens the modal if the user's isFirst is true
      // if (user?.userDetails?.isFirst) {
      // setIsModalOpen(true); // Open modal if isFirst is true
      // }
    }
  }, [isSignedIn, getCurrentSeasons]);

  // Initialize Section
  useEffect(() => {    
    initializeSession(); // call initializeSession
  }, [initializeSession]);

  useEffect(() => {
    if(currentSeason && currentSeason?._id){
      getCart({
        seasonId: currentSeason?._id
      });
      fetchPointsAndRewards({
        seasonId: currentSeason?._id
      });
      getLiveMatches({
        seasonId: currentSeason?._id
      });
    }
  }, [currentSeason?._id])

  useEffect(() => {
    if(!isSignedIn){
      isMounted.current = false;
      isMounted2.current = false;
      isMounted3.current = false;
    }
  }, [isSignedIn])

  useEffect(() => {
    if(user?.isSignUp){
      setIsModalOpen(true);
    }
  }, [user?.isSignUp])

  //USEEFFECT TO KEEP TABS IN SYNC ACCORDING TO THE USER-ID
  // useEffect(() => {
  //   const syncAcrossTabs = (e) => {
  //     if (e.key === 'user') {
  //       try {
  //         const newUser = JSON.parse(e.newValue);
  //         const newUserId = newUser?.userDetails?._id;
  
  //         if (newUserId && newUserId !== user?.userDetails?._id) {
  //           window.location.reload(); //  Full page reload if different user
  //         }
  //       } catch (err) {
  //         console.error('Failed to parse user from localStorage:', err);
  //       }
  //     }
  //   };
  
  //   window.addEventListener("storage", syncAcrossTabs);
  //   return () => window.removeEventListener("storage", syncAcrossTabs);
  // }, [user?.userDetails?._id]);
  
  if(fetchingSeasons)
    return <CommonLoader />

  if(user?.userDetails?.changePasswordNextLogin){
    return <RequestToChangePassword />
  }

  return (
    <BrowserRouter>
      {/* Toast Messages */}
      <CustomizedSnackbars />
      {/* Feedback Button & Modal */}
      <FeedbackButton />
      {/* Routes */}
      <MainRoutes />

      {/* This is the bonus point modal that opens when the user first logs in */}
      {isModalOpen && <UserFirstLoginModal isOpen={isModalOpen} onClose={handleModalClose} getUser={getUser} />}
    </BrowserRouter>
  )
}

// All Dispatches
const mapDispatchToProps = (dispatch) => ({
  getUser: () => dispatch(getUserDetails()),
  getCart: (data) => dispatch(getMyCart(data)),
  getSession: (data) => dispatch(session(data)),
  fetchUniversity: (data) => dispatch(fetchUniversityDetails(data)),
  getCurrentSeasons: (data) => dispatch(getCurrentSeasons(data)),
  fetchPointsAndRewards: (data) => dispatch(fetchUserPointsAndRewards(data)),
  passwordPolicies: () => dispatch(getPasswordPolicy()),
  getLiveMatches: (data) => dispatch(getLiveMatchesList(data)),
});

export default connect(null, mapDispatchToProps)(React.memo(App));